<template>
    <div></div>
</template>

<script>
import Vconsole from 'vconsole'

const vConsole = new Vconsole();
export default vConsole;
</script>